
// import React from 'react';
// import styled from 'styled-components';
// import RightArrow from '../../SVG/RightArrow';
// import { useNavigate } from 'react-router-dom';
// import dots from '../../Assest/cards/multiDots.avif'; // Changed to standard import to avoid "object" error

// const HomeServiceCard = ({ bg, data }) => {
//   let navigate = useNavigate();

//   // Theme color logic
//   let themeColor = "#ec4899"; // Fuchsia
//   if (bg === 'bg-white') themeColor = "#60a5fa"; // Blue
//   if (bg === 'bg-slate-600') themeColor = "#34d399"; // Emerald

//   return (
//     <StyledWrapper themeColor={themeColor}>
//       <div className="svc-card">
//         <div className="content">
//           {/* BACK SIDE (Shown first) */}
//           <div className="back">
//             <div className="back-content">
//               <div className='text-[10px] font-mono opacity-40 tracking-[0.3em] uppercase mb-4'>Merida HR</div>
//               <p className="text-sm md:text-base font-bold text-white text-center leading-snug px-6">
//                 {data.title}
//               </p>
//               <div className="mt-6 opacity-30 text-[10px] tracking-widest animate-pulse">HOVER TO FLIP</div>
//             </div>
//           </div>

//           {/* FRONT SIDE (Shown on hover) */}
//           <div className="front">
//             <div className="img-bg">
//               <div className="circle"></div>
//               <div className="circle" id="right"></div>
//               <div className="circle" id="bottom"></div>
//             </div>
//             <div className="front-content">
//               <div className="badge">SERVICE</div>
//               <div className="description">
//                 <h3 className="text-white font-bold text-xs mb-1.5 line-clamp-1">{data.title}</h3>
//                 <p className="text-white/70 text-[10px] leading-relaxed line-clamp-3">
//                   {data.content}
//                 </p>
//                 {data.included && (
//                   <ul className="mt-2 space-y-1">
//                     {data.included.slice(0, 4).map((item, i) => (
//                       <li key={i} className="text-[9px] text-white/60 flex items-center gap-1.5">
//                         <span className="w-1 h-1 bg-white/40 rounded-full flex-shrink-0"></span>
//                         <span className="line-clamp-1">{item}</span>
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </div>
//               <div className="flex justify-between items-center mt-auto">
//                 <img src={dots} className="w-12 opacity-30 mix-blend-screen" alt="dots" />
//                 <button
//                   onClick={() => navigate(`${data.slug}`)}
//                   className="px-3 py-1.5 rounded-full border border-white/20 hover:bg-white hover:text-black transition-all flex items-center gap-2 text-[9px] font-bold uppercase tracking-wider"
//                 >
//                   {data.cta ? data.cta : 'Explore'}
//                   <RightArrow size={14} />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </StyledWrapper>
//   );
// };

// const StyledWrapper = styled.div`
//   padding: 15px;
//   .svc-card { width: 100%; height: 380px; perspective: 1000px; }
//   .content {
//     width: 100%; height: 100%;
//     transform-style: preserve-3d;
//     transition: transform 0.6s cubic-bezier(0.23, 1, 0.32, 1);
//     position: relative;
//     border-radius: 20px;
//   }
//   .svc-card:hover .content { transform: rotateY(180deg); }
//   .front, .back {
//     position: absolute; width: 100%; height: 100%;
//     backface-visibility: hidden; border-radius: 20px; overflow: hidden;
//   }
//   .back {
//     background: #111; display: flex; justify-content: center; align-items: center; z-index: 2;
//   }
//   .back::before {
//     content: ''; position: absolute; width: 150px; height: 180%;
//     background: linear-gradient(90deg, transparent, ${props => props.themeColor}, transparent);
//     animation: rotate 4s infinite linear;
//   }
//   .back-content {
//     position: absolute; width: 98%; height: 98%; background: #080808;
//     border-radius: 19px; display: flex; flex-direction: column; justify-content: center; align-items: center;
//   }
//   @keyframes rotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
//   .front { transform: rotateY(180deg); z-index: 1; background: #000; }
//   .front-content {
//     position: relative; z-index: 10; height: 100%; padding: 25px;
//     display: flex; flex-direction: column; background: rgba(0,0,0,0.5); backdrop-filter: blur(8px);
//   }
//   .badge { font-size: 9px; font-weight: bold; background: rgba(255,255,255,0.1); padding: 3px 10px; border-radius: 5px; width: fit-content; }
//   .description { margin-top: 20px; padding: 15px; background: rgba(0,0,0,0.6); border-radius: 15px; border: 1px solid rgba(255,255,255,0.05); }
//   .circle { position: absolute; width: 100px; height: 100px; background: ${props => props.themeColor}; filter: blur(40px); opacity: 0.5; animation: float 3s infinite ease-in-out; }
//   #bottom { bottom: -20px; left: -20px; width: 150px; height: 150px; }
//   #right { top: -10px; right: -10px; animation-delay: -1.5s; }
//   @keyframes float { 0%, 100% { transform: translate(0,0); } 50% { transform: translate(10px, 15px); } }
// `;

// export default HomeServiceCard; // CRITICAL: Ensure this is default export



// import React from 'react';
// import { motion } from 'framer-motion';
// import { ArrowUpRight, CheckCircle2 } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';

// const HomeServiceCard = ({ data, isBlue, index }) => {
//     let navigate = useNavigate();

//     // Theme Logic
//     const cardClass = isBlue 
//         ? "bg-blue-600 text-white border-blue-500 shadow-[0_20px_50px_rgba(37,99,235,0.2)]" 
//         : "bg-white text-slate-900 border-blue-50 shadow-[0_20px_50px_rgba(0,0,0,0.04)]";

//     const iconColor = isBlue ? "text-cyan-300" : "text-blue-600";
//     const tagClass = isBlue ? "bg-white/10 text-white border-white/10" : "bg-blue-50 text-blue-700 border-blue-100";

//     return (
//         <motion.div
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.7, delay: index * 0.1 }}
//             whileHover={{ y: -12, transition: { duration: 0.3 } }}
//             className={`relative p-8 rounded-[2.5rem] border flex flex-col h-full transition-all group ${cardClass}`}
//         >
//             <div className="flex justify-between items-start mb-6">
//                 <div className={`w-12 h-12 rounded-2xl flex items-center justify-center ${isBlue ? 'bg-white/10' : 'bg-blue-50'}`}>
//                     <CheckCircle2 size={24} className={iconColor} />
//                 </div>
//                 <motion.button 
//                     whileHover={{ scale: 1.1, rotate: 45 }}
//                     onClick={() => navigate(data.slug)}
//                     className={`p-3 rounded-full border transition-all ${
//                         isBlue ? 'border-white/20 hover:bg-white hover:text-blue-600' : 'border-slate-200 hover:bg-blue-600 hover:text-white'
//                     }`}
//                 >
//                     <ArrowUpRight size={20} />
//                 </motion.button>
//             </div>

//             <div className="flex-grow">
//                 <h3 className="text-xl font-bold mb-4 syne leading-tight tracking-tight">{data.title}</h3>
//                 <p className={`text-[13px] leading-relaxed mb-8 ${isBlue ? 'text-blue-100/80' : 'text-slate-500'}`}>
//                     {data.content}
//                 </p>
//             </div>

//             {/* List of sub-services */}
//             <div className="flex flex-wrap gap-2 pt-6 border-t border-current border-opacity-10">
//                 {data.included.map((item, i) => (
//                     <span key={i} className={`text-[9px] font-black uppercase tracking-widest px-2.5 py-1.5 rounded-md border ${tagClass}`}>
//                         {item}
//                     </span>
//                 ))}
//             </div>
//         </motion.div>
//     );
// };

// export default HomeServiceCard;


// import React from 'react';
// import { motion } from 'framer-motion';
// import { ArrowUpRight, CheckCircle2 } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';

// const HomeServiceCard = ({ data, isBlue, index }) => {
//     let navigate = useNavigate();

//     // Theme Logic for White Background Compatibility
//     const cardClass = isBlue 
//         ? "bg-blue-600 text-white border-blue-500 shadow-2xl shadow-blue-600/20" 
//         : "bg-white text-slate-900 border-slate-200 border-l-[6px] border-l-blue-600 shadow-xl shadow-blue-900/5";

//     const iconColor = isBlue ? "text-cyan-300" : "text-blue-600";
//     const tagClass = isBlue 
//         ? "bg-white/10 text-white border-white/10" 
//         : "bg-blue-50 text-blue-700 border-blue-100";

//     return (
//         <motion.div
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6, delay: index * 0.1 }}
//             whileHover={{ 
//                 y: -12, 
//                 scale: 1.02,
//                 boxShadow: isBlue ? "0 30px 60px -12px rgba(37,99,235,0.4)" : "0 30px 60px -12px rgba(0,0,0,0.1)"
//             }}
//             className={`relative p-8 rounded-[2rem] border flex flex-col h-full transition-all group ${cardClass}`}
//         >
//             <div className="flex justify-between items-start mb-8">
//                 <div className={`w-12 h-12 rounded-2xl flex items-center justify-center ${isBlue ? 'bg-white/10 shadow-inner' : 'bg-blue-50'}`}>
//                     <CheckCircle2 size={24} className={iconColor} />
//                 </div>
//                 <motion.button 
//                     whileHover={{ scale: 1.1, rotate: 45 }}
//                     onClick={() => navigate(data.slug)}
//                     className={`p-3 rounded-full border transition-all ${
//                         isBlue ? 'border-white/20 hover:bg-white hover:text-blue-600' : 'border-slate-200 hover:bg-blue-600 hover:text-white hover:border-blue-600'
//                     }`}
//                 >
//                     <ArrowUpRight size={20} />
//                 </motion.button>
//             </div>

//             <div className="flex-grow">
//                 <h3 className="text-2xl font-bold mb-4 syne leading-tight tracking-tight">{data.title}</h3>
//                 <p className={`text-[14px] leading-relaxed mb-8 font-medium ${isBlue ? 'text-blue-100/80' : 'text-slate-500'}`}>
//                     {data.content}
//                 </p>
//             </div>

//             {/* List of sub-services (Directly Visible) */}
//             <div className={`flex flex-wrap gap-2 pt-6 border-t ${isBlue ? 'border-white/10' : 'border-slate-100'}`}>
//                 {data.included.map((item, i) => (
//                     <span key={i} className={`text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg border ${tagClass}`}>
//                         {item}
//                     </span>
//                 ))}
//             </div>
//         </motion.div>
//     );
// };

// export default HomeServiceCard;


import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, CheckCircle2, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import CTAButton from '../CTAButton';
import { GlobalEnquiryContext } from '../../App';

const HomeServiceCard = ({ data, isBlue, index }) => {
    let navigate = useNavigate();
    const { openEnquiry } = useContext(GlobalEnquiryContext);

    // Theme Logic
    const cardClass = isBlue
        ? "bg-blue-600 text-white border-blue-500 shadow-2xl"
        : "bg-white text-slate-900 border-slate-200 border-l-[6px] border-l-blue-600 shadow-xl shadow-blue-900/5";

    const iconColor = isBlue ? "text-cyan-300" : "text-blue-600";
    const tagClass = isBlue ? "bg-white/10 text-white" : "bg-blue-50 text-blue-700";

    return (
        <motion.div
            // ENTRANCE ANIMATION
            initial={{ opacity: 0, y: 50, rotateX: 20 }}
            whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{
                duration: 0.8,
                delay: index * 0.1,
                type: "spring",
                stiffness: 50
            }}
            // 3D MAGNETIC HOVER
            whileHover={{
                y: -15,
                rotateY: 5,
                rotateX: -5,
                transition: { duration: 0.4 }
            }}
            onClick={() => navigate(data.slug)}
            className={`relative rounded-[2.5rem] border flex flex-col h-full transition-all group perspective-1000 cursor-pointer overflow-hidden ${cardClass}`}
        >
            {/* Animated Glow Overlay */}
            <div className="absolute inset-0 rounded-[2.5rem] bg-gradient-to-br from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" />

            {data.image && (
                <div className="overflow-hidden h-48 w-full relative z-10">
                    <motion.img
                        src={data.image}
                        alt={data.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                </div>
            )}

            <div className="p-6 flex flex-col flex-grow relative z-10">
                <div className="flex-grow">
                    <motion.h3
                        className="text-xl font-bold mb-2 syne leading-tight tracking-tight group-hover:translate-x-2 transition-transform duration-500"
                    >
                        {data.title}
                    </motion.h3>
                    <p className={`text-sm group-hover:text-opacity-100 transition-all mb-4 ${isBlue ? 'text-white/95' : 'text-slate-700'}`}>
                        {data.content}
                    </p>
                </div>

                {data.cta && (
                    <div className="mt-auto mb-4 relative z-10 w-full flex justify-center">
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                openEnquiry(data.title || "Service Enquiry", []);
                            }}
                            className={`w-full py-3.5 rounded-xl font-bold text-[11px] uppercase tracking-wider flex items-center justify-center gap-3 transition-all shadow-lg ${isBlue
                                ? 'bg-[#01014C] text-white hover:bg-white hover:!text-[#01014C]'
                                : 'bg-[#01014C] text-white hover:bg-blue-600'
                                }`}
                        >
                            {data.cta}
                            <ArrowRight size={16} />
                        </button>
                    </div>
                )}

                {/* List of sub-services with staggered animation feel */}
                <div className={`flex flex-wrap gap-2 pt-4 border-t relative z-10 ${isBlue ? 'border-white/10' : 'border-slate-100'}`}>
                    {data.included.map((item, i) => (
                        <motion.span
                            key={i}
                            whileHover={{ scale: 1.1 }}
                            className={`text-xs font-semibold uppercase px-3 py-1.5 rounded-lg border border-transparent ${tagClass} group-hover:border-current group-hover:border-opacity-20 transition-all`}
                        >
                            {item}
                        </motion.span>
                    ))}
                </div>
            </div>

            {/* Bottom Accent line that grows on hover */}
            <motion.div
                initial={{ width: 0 }}
                whileHover={{ width: '60%' }}
                className={`absolute bottom-6 left-10 h-1 rounded-full ${isBlue ? 'bg-cyan-400' : 'bg-blue-600'} transition-all duration-500`}
            />
        </motion.div>
    );
};

export default HomeServiceCard;